import React from "react";
import { toast } from "sonner";
import { publicOrigin } from "@/lib/landerDomain";
import { Copy } from "@phosphor-icons/react";

// How to pass their click ID to us, so postbacks can hand it back.
export function TrackingLinkHelp({ link, ownerType }) {
  const origin = publicOrigin();
  const example = link?.value
    ? `${origin}/lp/standard?${link.param}=${link.value}&click_id=YOUR_CLICK_ID&sub=YOUR_SUB_ID`
    : null;
  const copy = () => {
    navigator.clipboard?.writeText(example).then(() => toast.success("Example link copied")).catch(() => {});
  };
  return (
    <div className="brut-card p-4 sm:p-5" data-testid="tracking-link-help">
      <div className="label-mono">Step 1 · Add your click ID to your links</div>
      <p className="text-sm mt-2 max-w-3xl">
        Put your tracker&apos;s click ID in a <code className="font-mono bg-zinc-100 px-1">click_id</code> parameter
        (we also accept <code className="font-mono bg-zinc-100 px-1">clickid</code> or <code className="font-mono bg-zinc-100 px-1">cid</code>).
        We keep it with the lead and send it back on every postback.
      </p>
      {example ? (
        <div className="mt-3 flex items-start gap-2">
          <code className="font-mono text-[11px] bg-zinc-50 border border-zinc-300 px-2 py-1.5 break-all flex-1" data-testid="tracking-link-example">{example}</code>
          <button type="button" onClick={copy} className="border border-black p-1.5 hover:bg-black hover:text-white" data-testid="tracking-link-copy" aria-label="Copy example link">
            <Copy size={14} />
          </button>
        </div>
      ) : (
        <div className="text-xs text-amber-800 mt-2" data-testid="tracking-link-missing">Your tracking code isn&apos;t set up yet. Ask your account manager.</div>
      )}
      {ownerType === "affiliate" && (
        <p className="text-xs text-zinc-600 mt-2">Sending leads by API? Include <code className="font-mono">&quot;click_id&quot;</code> in each lead you post.</p>
      )}
    </div>
  );
}
